import React, { useState, useEffect } from "react";
import "./App.css";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/home/home";
import Favourite from "./pages/home/favourite";
import Signup from "./pages/home/Signup";
import Login from "./pages/home/Login";
import ChatPage from "./pages/home/ChatPage";
import AdminHome from "./pages/admin/AdminHome";
import AdminLogin from "./pages/admin/pages/Login";
import EditCharacter from "./pages/admin/pages/EditCharacter";
import CreateCharacter from "./pages/admin/pages/CreateCharacter";
import SingleCharacterAnalytics from "./pages/admin/pages/SingleCharacterAnalytics";
import Callback from "./pages/callback";
import Pricing from "./pages/home/Pricing";
import Chats from "./pages/home/Chats";
import Setting from "./pages/home/Setting";
import Users from "./pages/admin/pages/Users";
import Revenue from "./pages/admin/pages/Revenue";
import User from "./pages/admin/pages/User";
import Support from "./pages/home/Support";
import SuccessfullPayment from "./pages/home/SuccessfulPayment";
import PricingModel from "./pages/admin/pages/PricingModel";
import RedirectToHome from "./RedirectToHome";
import BoosterManager from "./pages/admin/pages/BoosterQuantity";
import Audiobooks from "./pages/home/Audiobooks";

import "./coming.css";
import useFbclid from "./hooks/useFbclid";
import TermsOfService from "./pages/home/Terms-Of-Service";
import PrivacyPolicy from "./pages/home/Privacy-Policy";
import "intro.js/introjs.css";
import introJs from "intro.js";
import { emitter } from "./pages/home/context/event";
import UTMForm from "./pages/admin/pages/UTM";
import { useFirstVisitUTM } from "./hooks/usePreSignup";
import { usePostSignupUTM } from "./hooks/usePostSignupHook";
import PostSignUpModal from "./components/postSignup";

const startDesktopTour = () => {
  introJs()
    .setOptions({
      steps: [
        {
          element: "#desktop-element-1",
          intro: "Access chat prompts designed for fun conversations.",
        },
        {
          element: "#desktop-element-2",
          intro:
            "Access bonus short stories, novel chapters, and chat with the characters about their book.",
        },
      ],
    })
    .start();
};

const startMobileTour = () => {
  introJs()
    .setOptions({
      steps: [
        {
          element: "#mobile-element-1",
          intro:
            "Access fun and steamy chat prompts, bonus short stories, and novel chapters.",
        },
      ],
    })
    .start();
};

function App() {
  useFbclid();

  useFirstVisitUTM();

  const modalContent = usePostSignupUTM();
  const [showPostModal, setShowPostModal] = useState(false);

  useEffect(() => {
    if (modalContent) {
      setShowPostModal(true);
    }
  }, [modalContent]);
  const location = useLocation();

  emitter.on("onHistoryUpdate", (history) => {
    setTimeout(() => {
      if (history.length > 0) {
        const isChatRoute = location.pathname.startsWith("/chat/");
        if (isChatRoute) {
          const hasSeenTour = localStorage.getItem("hasSeenChatTour");
          if (!hasSeenTour) {
            const isMobile = window.innerWidth <= 768;
            if (isMobile) {
              startMobileTour();
            } else {
              startDesktopTour();
            }
            localStorage.setItem("hasSeenChatTour", "true");
          }
        }
      }
    }, 1000);
  });

  const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "bookTalk",
  ];

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const utmParams: Record<string, string> = {};

    UTM_KEYS.forEach((key) => {
      const value = queryParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });

    if (Object.keys(utmParams).length > 0) {
      if (
        Object.keys(utmParams).length == 1 &&
        Object.keys(utmParams).includes("bookTalk")
      )
        return; // account for book since that will be provied everywhere and it doesn't nessary means it UTM change event.
      // Store in localStorage
      localStorage.setItem("utm_params", JSON.stringify(utmParams));
      localStorage.removeItem("utm_first_visit_tracked");
      localStorage.removeItem("utm_pre_signup_tracked");
      console.log("Hmm");
    }
  }, [location.search]);

  return (
    <div className="App">
      <PostSignUpModal
        open={showPostModal}
        setOpen={setShowPostModal}
        htmlContent={modalContent?.htmlContent || ""}
      />

      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/chat/:id" element={<ChatPage />} />
        <Route path="/chat/:id/c/:c" element={<ChatPage />} />
        <Route path="/chat/:id/c/" element={<ChatPage />} />

        <Route path="/chats" element={<Chats />} />
        <Route
          path="/app/a379820595de2c435a868f12ad4d0392"
          element={<RedirectToHome />}
        ></Route>

        <Route path="/saved" element={<Favourite />} />
        <Route path="/price" element={<Pricing />} />
        <Route path="/audiobooks" element={<Audiobooks />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/support" element={<Support />} />
        <Route path="/successful-payment" element={<SuccessfullPayment />} />

        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />

        <Route path="/admin" element={<AdminHome />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/user/:id" element={<User />} />

        <Route path="/admin/revenue" element={<Revenue />} />
        <Route path="/admin/booster" element={<BoosterManager />} />

        <Route path="/admin/pricing-model" element={<PricingModel />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/edit-character/:id" element={<EditCharacter />} />
        <Route path="/admin/create-character" element={<CreateCharacter />} />
        <Route path="/admin/utm" element={<UTMForm />} />
        <Route
          path="/admin/character-analytics/:id"
          element={<SingleCharacterAnalytics />}
        />

        <Route path="/callback" element={<Callback />} />

        <Route path="/terms" element={<TermsOfService />}></Route>
        <Route path="/privacy" element={<PrivacyPolicy />}></Route>
      </Routes>
    </div>
  );
}

export default App;
